<template>
  <p class="UIInputDescription"><slot /></p>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.UIInputDescription {
  @include font-size-10px;
  color: $color-neutral-70;
}
</style>
